const GeneralPanel = () => import(/* webpackChunkName: "userGeneralPanel" */ '../../generalPanel/GeneralPanel');
const MyData = () => import(/* webpackChunkName: "myUserData" */ '../myData/MyData');

export default {
  path: '/usuario',
  component: GeneralPanel,
  children: [
    {
      path: 'meus-dados',
      name: 'my-account.my-data',
      component: MyData,
      meta: { breadcrumb: { name: 'page-name.my-data' } },
    },
  ],
};
